// Function to format cell value for display
export const formatCellValue = (value: any): string => {
    if (!value) {
        return "";
    }
    if (typeof value === "object") {
        return JSON.stringify(value);
    }
    return String(value);
};
